import { Icon } from '../components/Icon';

interface HomeScreenProps {
  onNew: () => void;
  onMovies: () => void;
  onHelp: () => void;
  onGrownUps: () => void;
}

export function HomeScreen({ onNew, onMovies, onHelp, onGrownUps }: HomeScreenProps) {
  return (
    <main className="home-screen">
      <section className="hero" aria-labelledby="home-title">
        <div className="hero-camera" aria-hidden="true"><Icon name="camera" /></div>
        <p className="eyebrow">Lights, camera, move!</p>
        <h1 id="home-title">Little Movie Maker</h1>
        <p>Move it. Snap it. Make a movie!</p>
      </section>
      <nav className="home-actions" aria-label="Main choices">
        <button className="home-card primary-card" type="button" onClick={onNew}>
          <span className="home-card-icon"><Icon name="camera" /></span>
          <span>Make a New Movie</span>
        </button>
        <button className="home-card" type="button" onClick={onMovies}>
          <span className="home-card-icon teal"><Icon name="movies" /></span>
          <span>My Movies</span>
        </button>
        <button className="home-card" type="button" onClick={onHelp}>
          <span className="home-card-icon yellow"><Icon name="help" /></span>
          <span>How to Make a Movie</span>
        </button>
      </nav>
      <p className="privacy-note"><span aria-hidden="true">🔒</span> Your pictures stay on this device — unless a grown-up turns on the Magic Eraser helper.</p>
      <button className="grownups-link" type="button" onClick={onGrownUps}>For Grown-Ups</button>
    </main>
  );
}

